module.exports = __webpack_public_path__ + "static/victoria-8eb6baa0af16c5f79ee3fc4bcfbc00c9.jpg";